import type { SelectedOverlay } from "../types";

export type OverlayPage = "squad" | "myTeam" | "entry" | "dreamTeam";

export const overlayPageConfig: Record<OverlayPage, SelectedOverlay[]> = {
  // /transfers and /squad-selection
  squad: [
    "opponent",
    "currentPrice",
    "sellingPrice",
    "points",
    "fdr",
    "price_change",
    "form",
    "ownership",
  ],
  // /my-team
  myTeam: [
    "opponent",
    "currentPrice",
    "sellingPrice",
    "points",
    "fdr",
    "price_change",
    "form",
    "ownership",
  ],
  // /entry/:entryId/event/:eventId
  entry: ["points", "currentPrice", "price_change", "form", "ownership"],
  // /team-of-the-week
  dreamTeam: ["points", "currentPrice", "price_change", "form", "ownership"],
};
